import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import isEmpty from 'lodash/fp/isEmpty';
import modulePropTypes from './modulePropTypes';
import { MobileHeaderModal } from './MobileHeaderModal';
export var MobileSubmoduleNavigation = function MobileSubmoduleNavigation(props) {
  var navItems = props.navItems,
    label = props.label,
    className = props.className;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isShown = _useState2[0],
    setIsShown = _useState2[1];
  var handleToggleNavigation = function handleToggleNavigation() {
    return setIsShown(!isShown);
  };
  var hasNavItems = !isEmpty(navItems);
  var classes = classNames('MobileSubmoduleNavigation', 'display-flex gap-10 align-items-center', 'padding-x-10', 'cursor-pointer', className);
  var labelClasses = classNames(hasNavItems ? 'text-size-12 text-color-dark line-height-14' : 'text-size-16 line-height-16 text-color-darkest text-medium text-uppercase', 'width-100pct ellipsis-1');
  return /*#__PURE__*/React.createElement("div", {
    className: classes,
    onClick: handleToggleNavigation
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex-1-1 display-flex flex-column align-items-center width-0"
  }, /*#__PURE__*/React.createElement("div", {
    className: labelClasses
  }, label), /*#__PURE__*/React.createElement("div", {
    className: "text-medium width-100pct"
  }, navItems.map(function (navItem) {
    return /*#__PURE__*/React.createElement("div", {
      key: navItem.key,
      className: "ellipsis-1"
    }, /*#__PURE__*/React.cloneElement(navItem.route, {
      className: 'text-size-16 line-height-16 text-color-darkest text-decoration-none',
      onClick: function onClick(event) {
        return event.preventDefault();
      }
    }));
  }))), hasNavItems && /*#__PURE__*/React.createElement("div", {
    className: "text-size-16 text-color-dark"
  }, /*#__PURE__*/React.createElement("span", {
    className: "rioglyph rioglyph-chevron-down"
  })), hasNavItems && /*#__PURE__*/React.createElement(MobileHeaderModal, {
    show: isShown
  }, navItems.map(function (navItem) {
    return /*#__PURE__*/React.createElement("div", {
      key: navItem.key,
      className: "margin-y-15 font-size-20"
    }, /*#__PURE__*/React.cloneElement(navItem.route, {
      className: 'text-size-20 text-color-darker'
    }));
  })));
};
MobileSubmoduleNavigation.defaultProps = {
  navItems: []
};
MobileSubmoduleNavigation.propTypes = {
  label: PropTypes.node,
  navItems: PropTypes.arrayOf(modulePropTypes),
  className: PropTypes.string
};